import type { FunctionComponent } from 'react';

import ClouderaLogo from './Cloudera';
import ConfluentLogo from './Confluent';
import DigicertLogo from './Digicert';
import HashicorpLogo from './Hashicorp';
import UiPathLogo from './UiPath';

//  Customer logos, used in <TrustedBy />
const CUSTOMER_LOGOS: Record<string, FunctionComponent> = {
  HashicorpLogo,
  ClouderaLogo,
  ConfluentLogo,
  DigicertLogo,
  UiPathLogo,
};

export default CUSTOMER_LOGOS;
